import React, { useEffect } from "react";
import styles from "./PropertyLegalModal.scss";
import cx from "../utils/cx";
import JsonApiRequest, { IFieldProvider } from "../utils/JsonApiRequest";
import LoadingIndicator from "./LoadingIndicator";
import DomPurify from "./DomPurify";

export interface IPropertyLegalModalProps {
  className?: string;
  providerId: number;
  statementType: 'legal' | 'privacy' | 'cancellation_policy';
}

const PropertyLegalModal: React.FC<React.PropsWithChildren<IPropertyLegalModalProps>> = ({ className = '', providerId, statementType }) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [providerData, setProviderData] = React.useState<IFieldProvider | null>(null);

    useEffect(() => {
    // load provider data
        JsonApiRequest.getRequest(`/real_estate_provider/real_estate_provider?filter[drupal_internal__id][value]=${providerId}`).then((res) => {
            const data = JsonApiRequest.data2Object<IFieldProvider>(res.getData())?.find((d) => true);
            setProviderData(data);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            setIsLoading(false);
        })
    }, []);

    const content = providerData?.[statementType]?.value || '';

    return (
        <div className={cx(styles.propertyLegalModal, className)}>
            {content && <DomPurify variant="legal" linkTarget="_blank" content={content} />}
            {isLoading && <LoadingIndicator className={styles.loading} />}
        </div>
    )
};

export default PropertyLegalModal;
